<template>
  <div>
    <b-row class="top-row">
      <b-col class="top-col">
        <h1 class="top-h1">Select Your Target Areas</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="top-col">
        Enter specific ZIP Codes below, or choose from various targeting methods like Radius or SFC Codes.
      </b-col>
    </b-row>
    <b-row class="top-row-1">
      <b-col class="top-col">
        <b-btn
          :variant="isZip ? 'primary' : ''"
          class="geoType"
          @click="tabtargt('zip')"
          >Enter ZIP Codes</b-btn
        >
        <b-btn
          :variant="isRadius ? 'primary' : ''"
          class="geoType"
          @click="tabtargt('radius')"
          >Radius around an Address or ZIP Code</b-btn
        >
        <b-dropdown
          :variant="!isRadius && !isZip ? 'primary' : ''"
          class="geoType"
          toggle-class="geoType"
          right
          :text="menuText"
        >
          <b-dropdown-group id="dropdown-group-1" header="STANDARD OPTIONS">
            <b-dropdown-item-button
              v-for="geo in geoTabs.list"
              :key="geo.name"
              :value="geo.name"
              @click="tabtargt(geo.name)"
              >{{ geo.title }}</b-dropdown-item-button
            >
          </b-dropdown-group>
          <b-dropdown-group id="dropdown-group-1" header="MAP OPTIONS">
            <b-dropdown-item-button
              v-for="geo in geoTabs.map"
              :key="geo.name"
              :value="geo.name"
              @click="tabtargt(geo.name)"
              >{{ geo.title }}</b-dropdown-item-button
            >
          </b-dropdown-group>
        </b-dropdown>
      </b-col>
    </b-row>
    <!-- <b-row align-h="center">
      <b-col lg="4" xl="4" md="4" sm="4" class="type-title"
        >Locate from List
        <b-form-select
          :value="listSelectValue"
          @change="tabtargt"
          class="type-select"
        >
          <b-form-select-option value="-1" disabled
            >Choose Category</b-form-select-option
          >
          <b-form-select-option
            v-for="geo in geoTabs.list"
            :key="geo.name"
            :value="geo.name"
            >{{ geo.title }}</b-form-select-option
          >
        </b-form-select>
      </b-col>
      <b-col lg="1" md="1" sm="1" class="or-s"><span>or</span></b-col>
      <b-col lg="4" xl="4" md="4" sm="4" class="type-title"
        >Locate from Map
        <b-form-select
          :value="mapSelectValue"
          @change="tabtargt"
          class="type-select"
        >
          <b-form-select-option value="-1" disabled
            >Choose Method</b-form-select-option
          >
          <b-form-select-option
            v-for="geo in geoTabs.map"
            :key="geo.name"
            :value="geo.name"
            >{{ geo.title }}</b-form-select-option
          >
        </b-form-select>
      </b-col>
    </b-row> -->
    <b-container fluid>
      <b-row class="geo-box">
        <b-col>
          <slot></slot>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-alert :show="alertDesc !== ''" variant="warning">{{
            alertDesc
          }}</b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row class="justify-content-center">
             <b-col sm="12" md="10">
              <span v-if="datasource.geoBasedCarrierRoutes">
                * Based on postal carrier routes
              </span>
             </b-col>
          </b-row>
         
        </b-col>
      </b-row>
      <b-row class="m-box-bottom">
        <div class="bootom-btn">
          <b-btn @click="goBack"> <icon name="arrow-left" class="btn-arrow" /> BACK </b-btn>
          <div class="next-box">
            <b-btn
              variant="primary"
              @click="preNext"
              data-test="geo-next"
              :disabled="nextDisabled"
              >NEXT STEP
            </b-btn>
            <!--<p class="next-desc">{{nextDesc}}</p>-->
          </div>
        </div>

       
      </b-row>
    </b-container>
  </div>
</template>

<script>
import MTab from "@/components/elements/MTab";
import _ from "lodash";

export default {
  components: {
    MTab,
  },
  props: {
    geoOption: {
      type: String,
      default: "zip",
    },
    title: {
      type: String,
    },
    goNext: {
      type: Number,
      default: 0,
    },
    needNext: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    datasource() {
      return this.$store.getters["config/datasource"];
    },
    alertDesc() {
      return this.$store.state.geo.alertDesc;
    },
    isMobile () {
      return this.$store.state.config.isMobile
    },
    geoTabs() {
      let result = {
        list: [],
        map: [],
      };
      let tabs = this.datasource.geoTabs.filter((t) => {
        return t.name !== "zip" && t.name !== "radius";
      });
      if(!this.isMobile){
        tabs = tabs.filter((t) => {
          return t.name !== "zipSelectMap" && t.name !== "zipPaste" && t.name !== "zipRange";
        });
      }
      if (tabs === undefined) {
        result = [];
      } else {
        result.list = tabs.filter((item) => item.type === 1);
        result.map = tabs.filter((item) => item.type === 2);
      }
      return result;
    },
    geoItems() {
      return this.$store.getters["order/geoItems"];
    },
    hasDemoAndPhoneOption() {
      return this.$store.getters["order/hasDemoAndPhoneOption"];
    },
    hasDemo() {
      return this.$store.getters["order/hasDemo"];
    },
    nextDesc() {
      if (this.hasDemoAndPhoneOption) {
        return "Poll Count";
      } else {
        return "Select Audience";
      }
    },
    listType() {
      return this.$store.state.order.ListType;
    },
    nextDisabled() {
      if (this.$store.state.order.CurrentStep === "count") {
        return true;
      }

      if (this.$store.state.order.GeoType === 24 && this.geoItems.length < 2) {
        return true;
      }

      if (
        (this.$store.state.order.GeoType === 5 &&
          this.$route.name === "geo-moreArea") ||
        this.$route.name === "geo-zip" ||
        this.$route.name === "geo-SCFCode"||
        this.$route.name === "geo-radius"||
        this.$route.name === "geo-Closex"||
        this.$route.name === "geo-moreArea"
      ) {
        return false;
      }
      if (
        this.geoItems.length === 0 &&
        this.$store.state.order.OrderAddresses.length === 0
      ) {
        return true;
      }
      return false;
    },
    isZip() {
      return this.$route.name.split("-")[1] === "zip";
    },
    isRadius() {
      return this.$route.name.split("-")[1] === "radius";
    },
    listSelectValue() {
      return this.datasource.geoTabs.filter(
        (item) =>
          item.type === 1 && item.name === this.$route.name.split("-")[1]
      ).length > 0
        ? this.$route.name.split("-")[1]
        : "-1";
    },
    mapSelectValue() {
      return this.datasource.geoTabs.filter(
        (item) =>
          item.type === 2 && item.name === this.$route.name.split("-")[1]
      ).length > 0
        ? this.$route.name.split("-")[1]
        : "-1";
    },
    menuText() {
      if (!this.isZip && !this.isRadius) {
        let geo = this.datasource.geoTabs.filter(
          (item) => item.name === this.$route.name.split("-")[1]
        );
        if (geo.length > 0) {
          return geo[0].title;
        } else {
          return "Other Types of Areas";
        }
      } else {
        return "Other Types of Areas";
      }
    },
  },
  methods: {
    preNext() {
      if (this.needNext) {
        this.$emit("go");
      } else {
        this.$store.dispatch("geo/next");
      }
    },
    goBack() {
      window.history.go(-1)
    },
    tabtargt(name) {
      if (name !== "-1") {
        let geos = this.datasource.geoTabs.filter((item) => item.name === name);
        let item = geos[0];
        this.$store.dispatch("order/changeGeoType", item.code);
        if (item.routeName) {
          if (item.code === 20) {
            this.$store.commit("order/addGeo", {
              GeoKeyCode: "1",
              GeoKeyDesc: "NATIONWIDE",
              GeoType: item.code,
            });
          }
          this.$router.push({ name: item.routeName });
        } else {
          this.$router.push({ name: "geo-" + item.name });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.m-tab-top-box {
  text-align: center !important;
}

.more {
  color: $color-primary;
}

.content {
  padding: 1.2em 2em;
}

.menu {
  float: right;
}

.header {
  display: flex;
  justify-content: space-between;
}

.next-desc {
  color: $color-border;
  font-size: 13px;
  margin-bottom: 0;
}

.next-box {
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
}

.bootom-btn {
  display: flex;
  align-items: center;
}

.top-btn {
  display: flex;
  align-items: flex-start;
  float: right;
}

.geo-box {
  margin-top: 16px;
}

.btn.dropdown-toggle {
  color: $color-text-grey;
}

.type-title {
  padding-top: 8px;
  padding-bottom: 8px;
  color: $color-black;
  text-align: center;
  font-size: 1.1rem;
}
.or-s {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-top: 20px;
}
.type-select {
  width: 90%;
}

.geoType{
  margin-top: 8px;
  min-width: 120px;
}

@media (max-width: 576px) {
  .or-s {
    display: block;
    align-items: center;
    padding-top: 8px;
    text-align: center;
  }
}
.top-row-1{
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/geo/M1GeoBox.vue